import { useEffect, useRef } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNativeOrderAlertRuntime } from '../lib/useNativeOrderAlertRuntime'
import { useOrderAlertListener } from '../lib/useOrderAlertListener'
import {
  registerPushTokenForPlace,
  unregisterPushTokenForPlace,
} from '../lib/nativeOrderAlerts'
import {
  shouldEnableOrderAlertRuntime,
  shouldStopOrderAlertRuntime,
} from '../lib/orderAlertRuntimePolicy'

/**
 * Keeps order-alert runtime session-scoped rather than route-scoped.
 * This prevents brief route/auth transitions from tearing down listeners.
 */
export function SessionOrderAlertRuntime() {
  const auth = useAuth()
  const authReady = Boolean(auth?.authReady)
  const hasUser = Boolean(auth?.user)
  const placeId = auth?.userProfile?.defaultPlaceId
  const userEmail = auth?.user?.email ?? undefined
  const activePushPlaceRef = useRef<string | null>(null)

  const runtimeEnabled = shouldEnableOrderAlertRuntime(authReady, hasUser)
  const shouldStop = shouldStopOrderAlertRuntime(authReady, hasUser)

  useNativeOrderAlertRuntime(runtimeEnabled, { shouldStopWhenDisabled: shouldStop })
  useOrderAlertListener(hasUser ? placeId : undefined)

  useEffect(() => {
    if (!hasUser || !placeId) {
      const prev = activePushPlaceRef.current
      if (prev) {
        void unregisterPushTokenForPlace(prev)
      }
      activePushPlaceRef.current = null
      return
    }
    activePushPlaceRef.current = placeId
    void registerPushTokenForPlace(placeId, userEmail)
  }, [hasUser, placeId, userEmail])

  return null
}
